module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-fuel-type"
  }, [_c('selectize', {
    attrs: {
      "options": _vm.fuelTypes,
      "maxItems": 1
    },
    on: {
      "itemAdded": _vm.selected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70affef0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/lists/FuelTypeSelect.vue
// module id = 2427
// module chunks = 1